import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { FormActionButton } from "../../../form/index.js";
const LoginPrimaryAction = forwardRef(
  function LoginPrimaryAction2(props, ref) {
    const {
      onClick,
      label,
      testId = "login-primary-onClick-root",
      disabled = false,
      componentProps,
      autoFocus = false,
      loading,
      loaderColor
    } = props;
    return /* @__PURE__ */ jsx(
      FormActionButton,
      {
        size: "large",
        color: "primary",
        variant: "contained",
        onClick,
        disabled,
        fullWidth: true,
        label,
        "data-testid": testId,
        "data-tidal": "LoginPrimaryAction",
        type: "submit",
        testId,
        autoFocus,
        ...componentProps,
        ref,
        loading,
        loaderColor
      }
    );
  }
);
export {
  LoginPrimaryAction
};
//# sourceMappingURL=LoginPrimaryAction.js.map
